import { Container, Typography, Badge } from "@/components/design-system";
import { POPULAR_DATA_GENERATORS } from "@/constants/categories";
import GeneratorCard from "@/components/partials/GeneratorCard";
import { TrendingUp } from "lucide-react";
import { useTranslations } from "next-intl";

export default function HomeDataGenerators() {
    const t = useTranslations('homepage.homeDataGenerators');
    return (
        <section className="py-24 bg-gradient-to-b from-muted/30 to-background">
            <Container>
                <div className="max-w-5xl mx-auto text-center mb-20">
                    <div className="animate-in fade-in-0 duration-1000">
                        <Badge variant="secondary" className="px-4 py-2 text-sm font-medium mb-6">
                            <TrendingUp className="w-4 h-4 mr-2" />
                            {t('badge')}
                        </Badge>
                    </div>
                    
                    <div className="animate-in fade-in-0 duration-1000 delay-200">
                        <Typography variant="h2" className="text-4xl md:text-5xl font-bold mb-6">
                            {t('title')}
                        </Typography>
                        <Typography variant="lead" className="text-xl text-muted-foreground max-w-3xl mx-auto">
                            {t('description')}
                        </Typography>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
                    {POPULAR_DATA_GENERATORS.map((generator, index) => (
                        <div 
                            key={generator.id}
                            className="animate-in fade-in-0 duration-1000"
                            style={{ animationDelay: `${400 + index * 100}ms` }}
                        >
                            <GeneratorCard generator={generator} isPopular />
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    )
}
